<div class="ttmodal">
  <div class="ttmodal__header">
      <span class="ttmodal__title">{{'Inspection Document Register' | translate : [] | async}}</span>
      <a class="button waves-effect" (click)="onCloseClick()">
        <i class="material-icons button__icon">cancel</i>
        <span class="button__text">{{'Close' | translate : [] | async}}</span>
      </a>
  </div>
     
    
    <div style="display: flex; flex-direction: row; justify-content: space-evenly;"> 
      <div style="display: flex; flex-direction: row;"> 
        <span style="font-size: 18px;">{{'Date' | translate : [] | async}} : </span>
        <span style="font-size: 18px;">{{InspectionDate}}</span>
  
      </div>
  
      <div style="display: flex; flex-direction: row;">
        <span style="font-size: 18px;">{{'SMU' | translate : [] | async}} : </span>
        <span style="font-size: 18px;">{{SMU}}</span>
      </div>
      <div style="display: flex; flex-direction: row; gap: 5px;">
        <mat-checkbox style="margin-left: 10px;" [checked]="includeInReport" (change)="onIncludeInReportChange($event)"></mat-checkbox>
        <span style="font-size: 18px;">{{'Include in Report (PDFs Only)' | translate : [] | async}}</span>
      </div>
    </div>
   
    
   

    <div style="display: flex;min-width: 100%;height:40px;margin-top: 3%;align-items: center; gap: 10px;">
       
      <span style="font-size: 14px;">{{'Attachments' | translate : [] | async}}</span>
      <button type="button" class="icon-btn add" (click)="openAttachDoc()" title="Attach Document"> + </button>  
        <div *ngFor="let form of attachmentList, let i =  index" style="display: flex;height:40px;justify-content: left;align-items: center; gap: 10px;">
          <i style="cursor: pointer;vertical-align: bottom; margin-left: 10%;font-size: 40px;
          color: #3da14b;"
            class="material-icons" class="material-icons" (click)="onClickDownloadForm(form)">description</i>
            <span style="cursor: pointer;font-size: 13px; max-width: 10em;">{{form.FileName}}</span>
          <span style=" white-space: nowrap;">
            
            <button type="button"
            class="icon-btn remove"
            (click)="openDeleteConfirmationBox(i)"
            title="Delete Document">
      ✖
    </button>
          </span>
        </div>      
            
    </div>

    <mat-divider></mat-divider>

    <div class="search-options"
      style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;height:auto;">
      <mat-form-field class="header-form-full-width">


        <input matInput [matDatepicker]="pickerStart" [(ngModel)]="startDate" [min]="InspectionDate"required>
        <mat-placeholder>{{'Select Date' | translate : [] | async}}</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pickerStart" ></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>

      

      <mat-form-field class="header-form-full-width">
        <mat-label>{{'User' | translate : [] | async}}</mat-label>
        <input type="text" matInput placeholder="{{'User' | translate : [] | async}}" [(ngModel)]="username" disabled>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="{{'Select Document Type' | translate : [] | async}}" [(ngModel)]="slectedDocTypeId">
          <mat-option [value]="doc.Id" *ngFor="let doc of DocTypes" >{{doc.Name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <div style="display: flex;" class="sc-row-margin">
        <div style="flex: 1">
          <h4 style="font-size: 14px;" class="get-label">{{'Comment' | translate : [] | async}}</h4>     
            <mat-form-field style="width: 818px;">  
              <textarea class="sc-textarea" matInput [(ngModel)]="DocComment" [ngModelOptions]="{standalone: true}"></textarea>
            </mat-form-field>    
        </div>
      </div>
      <div style="display: flex;flex-direction: row;justify-content: flex-end;align-self: flex-end;">
        <button mat-raised-button color="warn" [disabled]="loading" [class.loading]="loading" (click)="updateInspectionDoc()">
          <i class="material-icons button__icon">save</i><span class="button__text">
            {{'Save/Update' | translate : [] | async}}
          </span>
        </button>
      </div>
    </div>
  </div>



